import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { HttpDialogListValuesService } from './http-dialog-list-values.service'
import { TransactionMetadataSource } from './transaction-metadata.service'
import {
  DerivationRequest,
  DerivationResult,
  TransactionDerivationSource,
} from './transaction-derivation.service'

/**
 * The offline flag for derivations (PVAL-26685). On, the panel binds
 * {@link HttpTransactionDerivationService} and every derivation is answered by RPS; off, it binds
 * `StaticTransactionDerivationService`'s canned values and nothing is called.
 */
export const USE_HTTP_TRANSACTION_DERIVATION = true

/**
 * Derivations answered by `dialog-metadata/resolve`, as `type: "Derivation"` items (PVAL-26685).
 *
 * Shares the one resolve transport with the lists, rather than owning an `HttpClient` of its own,
 * so the URL, the `accountId` every item carries, the error opt-in and the reply matching are
 * written once.
 */
@Injectable()
export class HttpTransactionDerivationService extends TransactionDerivationSource {
  constructor(
    private readonly transport: HttpDialogListValuesService,
    private readonly metadata: TransactionMetadataSource,
  ) {
    super()
  }

  resolve(
    items: readonly DerivationRequest[],
    accountId: string,
  ): Observable<DerivationResult[]> {
    return this.transport
      .post(
        items.map(item => ({
          source: this.metadata.source,
          keyName: item.keyName,
          type: 'Derivation' as const,
          params: item.params,
        })),
        accountId,
      )
      .pipe(map(reply => reply.derivations))
  }
}
